import { validateReservationEngineVersion } from '../../utils/utils';
import { api } from './api';

export const fetchReservations = (params, options) => {
  const payload = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => payload.append(key, item));
    else return payload.append(key, value);
  });
  const url = '/reservation';
  return api.get(url, payload, options);
};

export const fetchNocMap = (params) => {
  return api.get('/reservation/noc_map', params);
};

export const fetchReservationById = (id, params = {}) => {
  return api.get(`/reservation/${id}`, params);
};

export const createReservation = (payload) => {
  const url = validateReservationEngineVersion(`/reservation`);
  return api.post(url, payload);
};

export const updateReservation = (id, payload) => {
  const url = validateReservationEngineVersion(`/reservation/${id}`);
  return api.put(url, payload);
};

export const fetchReservationRules = (params) => {
  return api.get(`/reservation/rules_set`, params);
};

export const startReservation = (id) => {
  const url = validateReservationEngineVersion(`/reservation/${id}/start`);
  return api.post(url);
};

export const endReservation = (id) => {
  const url = validateReservationEngineVersion(`/reservation/${id}/end`);
  return api.post(url);
};

export const cancelReservation = (id, payload) => {
  const url = validateReservationEngineVersion(`/reservation/${id}/cancel`);
  return api.post(url, payload);
};

export const addBrokerToReservation = (id, params) => {
  return api.post(`/reservation/${id}/broker`, params);
};

export const removeBrokerFromReservations = (id, broker) => {
  return api.delete(`/reservation/${id}/broker/${broker}`);
};

export const fetchBusinessHours = (params, options) => {
  const payload = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => payload.append(key, item));
    else return payload.append(key, value);
  });
  return api.get('/rules/business_hours_rules_set', payload, options);
};

export const fetchReservationStats = () => {
  const url = validateReservationEngineVersion(
    `/reservation/stats?statuses=RESERVED&statuses=INPROGRESS`
  );
  return api.get(url);
};

export const bulkActionReservations = (params) => {
  return api.post('/reservation/bulk-action', params);
};
